const setEmptyChildrenAsNull = (data) => {
  for (const item of data) {
    for (var k in item) {
      if (k === "children") {
        if (item[k] === "") {
          item[k] = null;
        } else {
          setEmptyChildrenAsNull(item[k]);
        }
      }
    }
  }
  return data;
};

const disableCurrentNodeAndItsChildren = (optionsList, currentItemId) => {
  for (const item of optionsList) {
    if (item.id === currentItemId) {
      item.isDisabled = true; // Property read by Vue Treeselect component
    }

    if (item.children) {
      disableCurrentNodeAndItsChildren(item.children, currentItemId);
    }
  }
};

const getChildrenLabelsRecursive = (node, labelsList) => {
  if (node.children) {
    for (const child of node.children) {
      labelsList.push(child.label);
      getChildrenLabelsRecursive(child, labelsList);
    }
  }
  return labelsList;
};

const getChildrenRecursive = (node, list) => {
  if (node.children) {
    for (const child of node.children) {
      list.push(child);
      getChildrenRecursive(child, list);
    }
  }
  return list;
};

const findNodeById = (tree, id) => {
  let node;
  tree.find(function iter(n) {
    if (n.id === id) {
      node = n;
      return true;
    }
    return Array.isArray(n.children) && n.children.some(iter);
  });
  return node;
};

const findVueTreeselectControlByRef = (ref) => {
  return ref.$children.find((child) => {
    return child.$options.name === "vue3-treeselect--control";
  });
};

const findInputTreeSelectByRef = (ref) => {
  const vueTreeselectControl = findVueTreeselectControlByRef(ref);
  if (!vueTreeselectControl) {
    throw new Error("Undefined treeselect for the following ref: " + ref);
  }

  let vueTreeselectValue = vueTreeselectControl?.$children.find((child) => {
    return child.$options.name === ref.multiple ? "vue3-treeselect--multi-value" : "vue3-treeselect--single-value";
  });
  if (ref.multiple) {
    vueTreeselectValue = vueTreeselectValue?.$children[0];
  }

  return vueTreeselectValue?.$children.find((child) => {
    return child.$options.name === "vue-treeselect--input";
  });
};

/**
 * Hook to set focus on label click AND open treeSelect Menu
 * openOnClick=true AND openOnFocus=true doesn't work, we can only have openOnClick=true OR openOnFocus=true
 * @param {string} ref
 */
const focusTreeSelectByRef = (ref) => {
  const vueTreeselectControl = findVueTreeselectControlByRef(ref);

  const vueTreeselectArrow = vueTreeselectControl?.$children.find((child) => {
    return child.$options.name === "vue3-treeselect--arrow";
  });

  const vueTreeselectArrowContainer = vueTreeselectArrow?.$el.parentElement;

  if (vueTreeselectArrowContainer) {
    const mousedownEvt = new MouseEvent("mousedown");
    vueTreeselectArrowContainer.dispatchEvent(mousedownEvt);
  }
};

export default {
  setEmptyChildrenAsNull,
  disableCurrentNodeAndItsChildren,
  getChildrenLabelsRecursive,
  getChildrenRecursive,
  findNodeById,
  findInputTreeSelectByRef,
  focusTreeSelectByRef,
};
